import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { SequenceModel } from './sequence-model';
export class VarientOperationDTO {
    @ApiProperty()
    @IsOptional()
    VarientOperationId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Varient Id not be empty" })
    variantId: number;
    @ApiProperty()
    @IsNotEmpty({ message: "Varient Code not be empty" })
    variantCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Sequence should not be empty" })
    sequenceData: SequenceModel[];
    
    
}

